export const PrivzetaVrednostTipEnum = {
  SAP: 1,
  MOBILNA_ST: 2,
  TV2GO_PRIKLJUCEK: 3,
  FIX_PRIKLJUCEK: 4
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/PrivzetaVrednostTipEnum.js